import React, { FC, useEffect, useId, useRef, useState } from "react";
import Heading from "components/Heading/Heading";
import Glide from "@glidejs/glide";
import OrganizationCard from "./CategoryCard";
import { BEARER_TOKEN } from "../../src/store/config";
import axios from "axios";
import TestimonioCard from "./TestimonioCard";

export interface SectionSliderTestimonioProps {
  className?: string;
  itemClassName?: string;
  heading?: string;
  headingFontClassName?: string;
  headingClassName?: string;
  subHeading?: string;
}

interface SliderItem {
  sliderId: number;
  description: string;
  imageName: string;
}

const SectionSliderProductCard: FC<SectionSliderTestimonioProps> = ({
  className = "",
  itemClassName = "",
  headingFontClassName,
  headingClassName,
  heading,
  subHeading = "",
}) => {
  const sliderRef = useRef<HTMLDivElement | null>(null);
  const id = useId();
  const UNIQUE_CLASS = "glidejs" + id.replace(/:/g, "_");

  const [productsIndexPresentation, setProductsIndexPresentation] = useState<SliderItem[]>([]);

  useEffect(() => {
    const fetchPaymentMethods = async () => {
      try {
        // const response = await axios.get(...);
        // setProductsIndexPresentation(response.data.data);

        // Valores en duro:
        setProductsIndexPresentation([
          { sliderId: 1, description: "", imageName: "pagina web-10.png" },
          { sliderId: 2, description: "", imageName: "pagina web-11.png" },
          { sliderId: 3, description: "", imageName: "pagina web-12.png" },
        ]);
      } catch (error) {
        console.error(error);
      }
    };

    fetchPaymentMethods();
  }, []);

useEffect(() => {
  if (!sliderRef.current) return;
  if (productsIndexPresentation.length === 0) return;

const OPTIONS: Partial<Glide.Options> = {
  perView: 3,
  gap: 32,
  bound: false,
  breakpoints: {
    1280: {
      perView: 3,
    },
    1024: {
      gap: 20,
      perView: 3,
    },
    768: {
      gap: 20,
      perView: 2,
    },
    640: {
      gap: 20,
      perView: 1.5,
    },
    500: {
      gap: 20,
      perView: 1.3,
    },
  },
};

  const slider = new Glide(`.${UNIQUE_CLASS}`, OPTIONS);
  slider.mount();

  return () => {
    slider.destroy();
  };
}, [productsIndexPresentation, UNIQUE_CLASS]);


  return (
    <div className={`nc-SectionSliderProductCard ${className}`}>
      <div className={`${UNIQUE_CLASS} flow-root`} ref={sliderRef}>
        <Heading
          isCenter
          className="text-[#671be5] mb-12"
          fontClass="text-3xl md:text-4xl font-bold"
          rightDescText={subHeading}
          hasNextPrev={false}
        >
          TESTIMONIO
        </Heading>

        <div className="glide__track" data-glide-el="track">
          <ul className="glide__slides flex justify-center gap-5">
  {productsIndexPresentation.map((item, index) => (
    <li key={index} className={`glide__slide flex justify-center ${itemClassName}`}>
      <TestimonioCard data={item} />
    </li>
  ))}
</ul>
        </div>
      </div>
    </div>
  );
};

export default SectionSliderProductCard;
